<template>
    <div id="today-view-hour-list"
         data-component="TodayViewHourList">
        <ul v-if="!loading">
            <li v-for="(data, hour) in hours"
                :id="`today-view-hour-list--${hour}`"
                :key="hour"
                :class="{active: parseInt(hour) === current}"
                @click="selectHour(hour)">
                <strong>{{ data.displayHour }}</strong>
                <small>
                    {{ data.sessionCount }}
                    {{ l(data.sessionCount === 1 ? 'TODAY_VIEW.SESSION' : 'TODAY_VIEW.SESSIONS').toLowerCase() }}
                </small>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'TodayViewHourList',

    props: {
        hours: {
            type: Object,
            required: true,
        },

        loading: {
            type: Boolean,
            default: false,
        },

        current: {
            type: Number,
            default: null,
        },
    },

    emits: [
        'select-hour',
    ],

    methods: {
        selectHour(hour) {
            this.$emit('select-hour', hour);
        },
    },
};
</script>

<style lang="less">
@import "../../../../../less/variables";

#today-view-hour-list {
    background: @dt-off-white-alt;
    height: 100%;
    width: 150px;
    overflow-y: auto;
    // scroll-behavior: smooth; // This breaks `.scrollIntoView()`.
    border-right: 1px @dt-light-grey solid;

    > ul {
        list-style: none;
        margin: 0;
        padding: 0;

        > li {
            display: block;
            padding: 12px;
            border-left: 5px solid transparent;
            border-bottom: 1px @dt-light-grey solid;
            white-space: nowrap;
            cursor: pointer;
            transition: all 0.1s ease-out;

            small {
                display: block;
            }

            &:hover {
                background: rgba(0, 0, 0, .1);
            }

            &.active {
                background: @white;
                border-left-color:  @dt-dark-blue; // Same colour as btn-info.active.
            }
        }
    }
}
</style>
